// currency input directive
import { Directive } from '@angular/core';

@Directive({
  selector: '[numberPhone]',
  host: {
    '(keydown)': 'validateNumber($event)',
    '(keyup)': 'formatNumber($event)',
  },
})
export class NumberPhoneDirective {
  constructor() {}
  // array of valids keys  for currency input
  private validKeys = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    'Del',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '+',
  ];

  validateNumber(event: KeyboardEvent) {
    if (!this.validKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  formatNumber($event) {
    const input = $event.target as HTMLInputElement;
    let value = '';

    if (input.value[0] === '+') {
      value = input.value[0] + input.value.slice(1).replace(/\D/g, '');
    } else {
      value = input.value.replace(/\D/g, '');
    }
    // $event.target.value = value;

    $event.target.value = value;
    $event.target.dispatchEvent(new Event('input'));
  }
}
